import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { MessageService, MenuItem } from 'primeng/api';
import { RiderService } from 'app/services';
import { VehicleStatusEnum } from 'app/models';
import { OnboardingVehiclesComponent } from 'app/components/home/home-existing-drivers/onboarding-vehicles/onboarding-vehicles.component';
import { Utils } from 'app/utils';
import { cl } from '@fullcalendar/core/internal-common';

enum MenuTab {
    VehicleDetails = 1,
    VehicleRequirements = 2,
    TNCRequirements = 3
}

@Component({
    selector: 'sidebar-existing-rider-vehicle-detail',
    templateUrl: './sidebar-existing-rider-vehicle-detail.component.html',
    styleUrls: ['./sidebar-existing-rider-vehicle-detail.component.scss',
        '../../../../../../styles/sidebar.scss'
    ],
    providers: [MessageService]
})
export class SidebarExistingRiderVehicleDetailComponent implements OnInit {
    public riderVehicleServiceTypeId!: number;
    @Input()
    set _riderVehicleServiceTypeId(value: number) {
        this.riderVehicleServiceTypeId = value;
        if (this.riderVehicleServiceTypeId > 0) {
            this.getRiderVehicleInfo();
        }
    }

    public riderVehicleId!: number;
    @Input()
    set _riderVehicleId(value: number) {
        this.riderVehicleId = value;
    }

    public riderId!: number;
    @Input()
    set _riderId(value: number) {
        this.riderId = value;
    }

    public visibleSidebarRiderVehicleDetail: boolean = false;
    @Input()
    set _visibleSidebarRiderVehicleDetail(value: boolean) {
        this.visibleSidebarRiderVehicleDetail = value;
    }

    @Output() changedVisibleSidebarRiderVehicleDetailEmit = new EventEmitter<boolean>();
    changedVisibleSidebarRiderVehicleDetail(increased: any) {
        this.changedVisibleSidebarRiderVehicleDetailEmit.emit(increased);
    }

    @Input() public onboardingVehiclesComponent!: OnboardingVehiclesComponent;

    constructor(private messageService: MessageService,
        private riderService: RiderService) {
    }

    public vehicleStatusEnum = VehicleStatusEnum;

    public riderVehicleInfo: any = null;

    public loading: boolean = false;

    public menuTab = MenuTab;
    public activeTab: MenuTab = MenuTab.VehicleDetails;
    public menuItems: MenuItem[] = [
        {
            label: 'Vehicle Details',
            command: (e: any) => this.handleTabChange(MenuTab.VehicleDetails)
        },
        {
            label: 'Vehicle Requirements',
            command: (e: any) => this.handleTabChange(MenuTab.VehicleRequirements)
        },
        {
            label: 'TNC Requirements',
            command: (e: any) => this.handleTabChange(MenuTab.TNCRequirements)
        }
    ];

    public isVisibleImageModal: boolean = false;
    public imageArray: string[] = [];

    ngOnInit(): void {
    }

    public showVisibleImageModal(images: string[]) {
        this.imageArray = images;
        this.isVisibleImageModal = true;
    }

    public handleTabChange(menuTab: MenuTab) {
        this.activeTab = menuTab;
    }

    getRiderVehicleInfo() {
        this.loading = true;
        this.riderVehicleInfo = null;

        const dto = {
            RiderVehicleServiceTypeId: this.riderVehicleServiceTypeId
        };

        this.riderService.getRiderVehicleInfo(dto, this.messageService)
            .then(data => {
                if (!data.Success) {
                    this.riderVehicleInfo = null;
                    this.loading = false;
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }
                this.riderVehicleInfo = data;
                this.riderVehicleInfo.CreateAtText = Utils.utcToLocaleDateString(this.riderVehicleInfo.CreatedAt);
                this.riderVehicleInfo.TimeText = Utils.utcToLocaleTimeString(this.riderVehicleInfo.CreatedAt);
                this.riderVehicleInfo.ConfirmedText = Utils.utcToLocaleString(this.riderVehicleInfo.ConfirmedAt);
                this.loading = false;
            })
            .catch(err => {
                this.riderVehicleInfo = null;
                this.loading = false;
                throw err;
            });
    }

    cancel() {
        this.changedVisibleSidebarRiderVehicleDetail(false);
    }
}
